module.exports = __webpack_public_path__ + "static/img/slide_2.f4cb1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/slide_2.png
// module id = QLu6
// module chunks = 0